import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const hammerheadIntegrationService = {
    connect: () => {
        const clientId = import.meta.env.VITE_HAMMERHEAD_CLIENT_ID;
        
        if (!clientId) {
            console.error("Hammerhead Client ID is missing. Check your .env files.");
            alert("Hammerhead integration is not configured for this environment.");
            return;
        }
        
        const rawRedirectUri = window.location.origin + '/hammerhead-callback';
        console.log("Initiating Hammerhead Auth. Ensure this Redirect URI is allowed in Hammerhead Portal:", rawRedirectUri);
        
        // DEBUG: Output the exact params being sent so they can be verified against the Portal
        console.group("Hammerhead Auth Debug");
        console.log("Client ID:", clientId);
        console.log("Sending Redirect URI:", rawRedirectUri);
        console.log("If you are landing on the Dashboard home page, 'Redirect URI' or 'Client ID' is likely a mismatch.");
        console.groupEnd();
        
        const redirectUri = encodeURIComponent(rawRedirectUri);
        
        // Standard Hammerhead scopes mapped from their API spec
        const scope = encodeURIComponent('activity:read offline_access');
        
        // Generate and store a state parameter for security
        const state = Math.random().toString(36).substring(2, 15);
        sessionStorage.setItem('hammerhead_oauth_state', state);

        // Use the official Hammerhead API authorization endpoint. 
        // We include audience to ensure Auth0 returns a JWT valid for the API, not an opaque token.
        const audience = encodeURIComponent('https://api.hammerhead.io');
        const authUrl = `https://api.hammerhead.io/v1/auth/oauth/authorize?audience=${audience}&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}`;

        console.log("FULL OAUTH URL (Click to test manually):", authUrl);
        
        // Redirect to Hammerhead OAuth page
        window.location.href = authUrl;
    },

    handleCallback: async (code: string): Promise<void> => {
        try {
            const redirectUri = window.location.origin + '/hammerhead-callback';
            const exchangeHammerheadToken = httpsCallable(functions, 'exchangeHammerheadToken');
            await exchangeHammerheadToken({ code, redirectUri });
        } catch (error: any) {
            console.error("Failed to exchange Hammerhead token:", error);
            throw error;
        }
    },

    disconnect: async (): Promise<void> => {
        const disconnectHammerhead = httpsCallable(functions, 'disconnectHammerhead');
        await disconnectHammerhead();
    },

    verifyConnection: async (): Promise<string | null> => {
        try {
            const verifyHammerheadToken = httpsCallable(functions, 'verifyHammerheadToken');
            const result = await verifyHammerheadToken();
            return result.data as string | null;
        } catch (error) {
            console.error("Hammerhead verification failed:", error);
            return null;
        }
    }
};